(function () {
  var zipCodeInput = document.getElementsByName("address[zip]");
  var phoneNumberInput = document.getElementsByName("address[phone]");
  var selectors = document.querySelectorAll('input[type="text"]');

  function validateZIP_CODE(node) {
    const zipCodeInput = node;

    // Check initial value and add Validation to it to remove white spaces at the begining
    zipCodeInput.value = zipCodeInput.value.replace(/\s/g, "");

    // Force removing spaces as first letters
    zipCodeInput.addEventListener("input", (e) => {
      e.target.value = e.target.value.replace(/\s/g, "");
    });

    // Prevent user from typing space as first letter
    zipCodeInput.addEventListener("keydown", function (e) {
      if (e.key === " " && zipCodeInput.selectionStart === 0) {
        e.preventDefault();
      }
    });

    //Block populate input by pasting
    zipCodeInput.addEventListener("paste", function (e) {
      e.preventDefault();
    });
  }

  function validatePhoneNumber(node) {
    const phoneInput = node;

    //Block addining value to input by pasting
    phoneInput.addEventListener("paste", function (e) {
      e.preventDefault();
    });

    phoneInput.addEventListener("keydown", function (e) {
      if (e.key === " ") {
        e.preventDefault();
      }
      // Only ASCII character in that range allowed
      let ASCIICode = e.keyCode;
      if (
        !(
          (ASCIICode >= 48 && ASCIICode <= 57) ||
          (ASCIICode >= 96 && ASCIICode <= 105) ||
          ASCIICode == 8
        ) ||
        !isNumeric(e.key)
      ) {
        e.preventDefault();
      }
    });
  }

  function isNumeric(value) {
    if (value === "Backspace") {
      return true;
    }
    return !isNaN(parseFloat(value)) && isFinite(value);
  }

  function init() {
    //Call function for phone number validation
    phoneNumberInput.forEach((number) => {
      validatePhoneNumber(number);
    });
    //Call function for zip code validation
    zipCodeInput.forEach((zip) => {
      validateZIP_CODE(zip);
    });

    //Call function for add field validation
    // Türkçe sesli harf girişlerini desteklemiyor. Kod yorum satırına alındı.
    //  selectors.forEach((singleInputData)=> {
    //    window.latinCharacters(singleInputData);
    //  });
  }

  // Initiate functions
  document.addEventListener("DOMContentLoaded", function () {
    init();
  });
})();
